export default {
  fleet_memberships: {
    create: "Membre déjà présent ou a une invitation en attente",
  },
};
